// @packages
import React from 'react';
import { Navigate } from 'react-router-native';
import { Image } from 'react-native';
import { StatusBar } from 'expo-status-bar';
import { KeyboardAwareScrollView } from 'react-native-keyboard-aware-scroll-view';

// @scripts
import LoginForm from '../../components/organisms/login-form';
import { useAuth } from '../../core/context/provider';
import { routes } from '../../core/routes/config';
import useStyles from './styles';

const Login = () => {
  const styles = useStyles();
  const { user } = useAuth();

  if (user?.siteIds?.length) {
    return <Navigate to={routes.dashboard.path} replace />;
  }

  return (
    <>
      <StatusBar style="auto" />
      <KeyboardAwareScrollView
        resetScrollToCoords={{ x: 0, y: 0 }}
        contentContainerStyle={styles.container}
        scrollEnabled
      >
        <Image style={styles.image} source={require('../../../assets/logo.png')} />
        <LoginForm />
      </KeyboardAwareScrollView>
    </>
  );
};

export default Login;
